import LazyLoadImages from "./events/ImageLoaded";

import StarterKit from "./StarterKit";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockHubs from "./blocks/BlockHubs";
import BlockImageGrid from "./blocks/BlockImageGrid";
import BlockSliderMultiple from "./blocks/BlockSliderMultiple";
import BlockSliderSimple from "./blocks/BlockSliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockProfiles from "./blocks/BlockProfiles";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSliderImageBackgroundText from "./blocks/BlockSliderImageBackgroundText";
import BlockSliderMultipleText from "./blocks/BlockSliderMultipleText";

// First of the first
new LazyLoadImages();

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	new StarterKit();

	// Blocks
	new BlockBanner();
	new BlockCollapse();
	new BlockHubs();
	new BlockImageGrid();
	new BlockMap();
	new BlockProfiles();
	new BlockQuotes();
	new BlockSliderImageBackgroundText();
	new BlockSliderSimple();
	new BlockSliderMultiple();
	new BlockSliderMultipleText();
});

window.initMap = function () {
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};
